<div class="language-container" [ngClass]="{ 'en': currentLanguage === 'en', 'he': currentLanguage === 'he' }">
  <p-tree
      #treeComponent
      [value]="[tree]"
      [filter]="true"
      filterBy="searchableText"
      filterMode="contains"
      [filterDelay]="500"
      [filterFunction]="customTreeFilter"
      containerStyleClass="w-full"
      [emptyMessage]="('iaa.emptySearchMessage' | translate) "
      [filterInputAutoFocus]="false"
      scrollHeight="300px"
      [virtualScroll]="enableVirtualScroll"
      [virtualScrollItemSize]="40"
      [virtualScrollOptions]="{ lazy: false }"
      [autofocus]="false"
      [styleClass]="'plus-icon'"
      class="w-full md:w-50rem"
      [(expandedKeys)]="expandedKeys"
      selectionMode="single"
      [(selection)]="selectedNode"
      (onNodeSelect)="handleSelection($event)"
  >
      <ng-template pTemplate="filtericon" let-filter>
          <i class="pi pi-search search-icon" 
             [ngStyle]="currentLanguage === 'en' ? { 'margin-right': '5px', 'margin-left': '0', 'transform': 'scaleX(-1)' } : { 'margin-left': '5px', 'margin-right': '0', 'transform': 'scaleX(1)' }">
          </i>
      </ng-template>
      <ng-template let-node pTemplate="default">
          <div class="item" 
               (click)="onNodeClick($event, node)"
               style="cursor: pointer;">
              <div class="item-label">
                  <span>{{ node.multiLangLabel | translateLang | async }}</span>
                  <ng-container *ngIf="showHoverLabel">
                      <div *ngIf="!isNodeSelected(node)" class="hover-text">
                          <i class="pi pi-plus add-remove-icon"></i> {{'iaa.general.add' | translate }}
                      </div>
                  </ng-container>
                  <!-- Search Type Icon for Advanced Thesaurus (only for regular nodes, not category headers or all-categories root) -->
                  <!-- <img *ngIf="node.styleClass !== 'category-header-node' && node.styleClass !== 'all-categories-root'" 
                       [src]="getSearchTypeIcon(node)" 
                       [alt]="'iaa.app.advancedSearch.selectSearchType' | translate" 
                       class="node-search-type-icon"
                       role="button"
                       tabindex="0"
                       [attr.aria-label]="'iaa.app.advancedSearch.selectSearchType' | translate"
                       (mousedown)="$event.stopPropagation(); $event.preventDefault()"
                       (click)="$event.stopPropagation(); openSearchTypePopup($event, node)"
                       (keydown)="handleSearchTypeIconKeydown($event, node)"
                       [pTooltip]="'בחר סוג חיפוש'"
                       tooltipPosition="top"
                       style="margin-left: 8px; margin-right: 8px; cursor: pointer;" /> -->
              </div>
              
              <!-- Matching word indicator for equal/unpref matches -->
              <div *ngIf="node.matchingWord" 
                   class="matching-word-label" 
                   [ngClass]="{'en': currentLanguage === 'en', 'he': currentLanguage === 'he'}">
                <span class="matching-word-text">{{ node.matchingWord.text }}</span>
                <img [src]="node.matchingWord.type === 'equal' ? 'assets/equal.svg' : 'assets/unpref.svg'" 
                     alt="" 
                     class="matching-word-icon" />
              </div>
          </div>
      </ng-template>
  </p-tree>

  <!-- Search Type Selection Popup -->
  <app-search-type-selector 
    #searchTypeSelector
    [value]="currentNode ? getNodeSearchType(currentNode) : 'branch'"
    [uniqueId]="getCurrentNodeId()"
    (valueChange)="onSearchTypeChange($event)">
  </app-search-type-selector>
</div>
